import { formatNumber } from '@emma-helpers/format.helper';
import { plural, TIME_HOURS, TIME_UNIT } from 'emma-common-ts';

const formatTime = (value: number, unit: TIME_UNIT) => {
  switch (unit) {
    case TIME_UNIT.YEARS: {
      const years = value / TIME_HOURS.YEAR;
      return plural(years, {
        1: $localize`${years} año`,
        other: $localize`${years} años`,
      });
    }
    case TIME_UNIT.MONTHS: {
      const months = value / TIME_HOURS.MONTH;
      return plural(months, {
        1: $localize`${months} mes`,
        other: $localize`${months} meses`,
      });
    }
    case TIME_UNIT.DAYS: {
      const days = value / TIME_HOURS.DAY;
      return plural(days, {
        1: $localize`${days} día`,
        other: $localize`${days} días`,
      });
    }
    case TIME_UNIT.HOURS:
    default: {
      return plural(value, {
        1: $localize`${value} hora`,
        other: $localize`${value} horas`,
      });
    }
  }
};

export const formatDataTypeTimeWindow = (value: number | string | null | undefined, unit?: TIME_UNIT) => {
  value = Number(value);
  if (unit) {
    return formatTime(value, unit);
  } else if (value <= 0) {
    return $localize`Vitalicia`;
  } else if (value >= TIME_HOURS.YEAR) {
    return formatTime(value, TIME_UNIT.YEARS);
  } else if (value >= TIME_HOURS.MONTH) {
    return formatTime(value, TIME_UNIT.MONTHS);
  } else if (value >= TIME_HOURS.DAY) {
    return formatTime(value, TIME_UNIT.DAYS);
  }
  return formatTime(value, TIME_UNIT.HOURS);
};

export const formatDataTypeDays = (value: number | string | null | undefined) => {
  if (value !== undefined) {
    value = Number(value);
    const amount = formatNumber(value);
    if (value === 1) {
      return $localize`${amount}:amount: día`;
    } else if (value > 180) {
      return $localize`+ ${amount}:amount: días`;
    } else {
      return $localize`${amount}:amount: días`;
    }
  }
  return '';
};
